'use strict';

var util = angular.module('gymsystem.util');

util.directive('upcomingactivity', ['$rootScope', 'util', 'server', '$interval', '$modal', 'live', '$timeout', '$location', function($rootScope, util, server, $interval, $modal, live, $timeout, $location) {
    return {
        restrict: 'E',
        template: '<div ng-include="\'views/upcomingactivity.html\'"></div>',
        scope: {
            settings: '='
        },
        link: function($scope) {
            $scope.numOfActivities = 1; // Todo: Read from widget settings when implemented

            function calculateDHM() {
                var now = new Date();
                for (var i = 0; i < $scope.upcomingActivities.length; i ++) {
                    var remaining = $scope.upcomingActivities[i].startTime.getTime() - now.getTime();
                    var minutes = Math.floor(remaining / (1000 * 60));
                    var hours = Math.floor(minutes / 60);
                    $scope.upcomingActivities[i].days = Math.floor(hours / 24);
                    $scope.upcomingActivities[i].hours =  hours % 24;
                    $scope.upcomingActivities[i].minutes = minutes % 60;
                }
            }

            $scope.upcomingActivities = [];
            function getActivities() {
                var start = new Date();
                var end = start.clone().addMonths(3);
                $scope.upcomingActivities = [];
                server.post2('/api/resourcebooking/resource/get_resource_allocation', {resource_ids: [$rootScope.currentStaffId], start: start, end: end, include_age: true}).then(function(response) {
                    response.forEach(function(res) {
                        if (res.origin_type === 'Workout') {
                            var target = _.find($scope.upcomingActivities, function(ua) { return ua.workout.id === res.origin_id; });
                            var activityTitle = res.origin.workoutType.name + ((res.origin.extra_title) ? ' - ' + (res.origin.extra_title) : '');
                            if (target) {
                                target.id = res.id;
                                target.startTime = res.start;
                                target.endTime = res.end;
                                target.workoutType = res.origin.workoutType;
                                target.numBooked = res.origin.numBooked;
                                target.minAgeBooked = res.minAgeBooked;
                                target.maxAgeBooked = res.maxAgeBooked;
                                target.workout = res.origin;
                                target.title = activityTitle;
                            } else {
                                $scope.upcomingActivities.push({
                                    'id': res.id,
                                    'startTime': res.start,
                                    'endTime': res.end,
                                    'workoutType': res.origin.workoutType,
                                    'numBooked': res.origin.numBooked,
                                    'minAgeBooked': res.minAgeBooked,
                                    'maxAgeBooked': res.maxAgeBooked,
                                    'workout': res.origin,
                                    'title': activityTitle
                                });
                            }
                            $scope.upcomingActivities = $scope.upcomingActivities.filter(function(ua) { return ua.endTime > start; }).sort(function(a, b) { return a.startTime.getTime() - b.startTime.getTime(); });
                            calculateDHM();
                        }
                    });
                });
            }

            $scope.isFutureOrOngoingActivity = function(ua) {
                var next = _.find($scope.upcomingActivities, function(a) {
                    if (a.id == ua.id) { return false; }
                    var tenBefore = a.startTime.clone();
                    tenBefore.addMinutes(-10);
                    return !tenBefore.isFuture() && a.startTime.isFuture();
                });
                if (next) { return false; }
                return ua.endTime.isFuture();
            };
            $scope.isOngoingActivity = function(ua) {
                return !ua.startTime.isFuture() && ua.endTime.isFuture();
            };

            $scope.showAttendance = function(workout) {
                $location.path('/attendance/show/' + workout.id);
                $scope.$dismiss();
            };

            $scope.add = function(workout) {
                $modal.open({
                    templateUrl: 'views/bookingadd.html',
                    controller: 'WorkoutBookingAddModalCtrl',
                    windowClass: 'huge-modal-window',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
            };

            $scope.invite = function(workout) {
                server.get('/api/workoutBooking/invites/get', {workout_id: workout.id}).then(function(invites) {
                    invites.forEach($rootScope.transformInvitation);
                    workout.bookings.forEach($rootScope.transformWorkoutBooking);
                    $modal.open({
                        templateUrl: 'views/addmodal.html',
                        controller: 'InviteAddModalCtrl',
                        resolve: {
                            workout: function() {
                                return workout;
                            },
                            invites: function() {
                                return invites;
                            }
                        }
                    });
                });
            };

            $scope.sendMailing = function(workout) {
                var receivers = workout.bookings.map(function(wb) { return $rootScope.getMember(wb.user_id); });
                $scope.pubsub.publish('newmailingdata', {
                    isNewsOrAdvertising: false,
                    sendOption: 'mail',
                    receivers: receivers,
                    options: { 'callCloseOnSuccess': true, 'modalMode': true }
                });
                $modal.open({
                    templateUrl: 'views/mailingnew.html',
                    windowClass: 'huge-modal-window',
                    controller: 'NewMailingCtrl'
                });
            };

            $scope.cancel = function(workout) {
                $modal.open({
                    templateUrl: 'views/cancelworkout.html',
                    controller: 'CancelWorkoutCtrl',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
            };

            getActivities();
            $interval(getActivities, 60000);

            live.subscribe({
                type: 'workout',
                scope: $scope,
                callback: function() {
                    getActivities();
                }
            });

            live.subscribe({
                type: 'workoutbooking',
                scope: $scope,
                callback: function() {
                    getActivities();
                }
            });
        }
    };
}]);

